import classNames from "classnames/bind";
import { ListingInductees } from "./ListingInductees"
import { Image, RhLink } from "@components";

import styles from './ListingInductees.module.scss';
const cx = classNames.bind(styles);

type ListingInductee = ListingInductees[number];

export default function ListingInducteeCard({ title, pageData, uri }: ListingInductee) {
  const { featuredImage } = pageData;
  return (
    <RhLink href={uri} className={cx("listing-inductee-card")}>
      <div className={cx(["image-wrapper"])}>
        <Image image={featuredImage} />
      </div>
      <p className="title-lc-xs">{title}</p>
    </RhLink>
  );
}